<template>
    <button
        class="button is-warning"
        @click.prevent="onApproveClick">Approve</button>
</template>

<script>
export default {
  name: 'ApproveButton',
  data () {
    return {}
  },
  methods: {
    onApproveClick () {
      this.$emit('approved')
    }
  }
}
</script>

<style scoped>

</style>
